import { createI18n } from 'vue-i18n'
import esES from '../lang/es-ES.json'
import enUS from '../lang/en-US.json'

const i18n = createI18n({
  legacy: false,
  locale: 'en-US',
  messages: {
    'es-ES': esES,
    'en-US': enUS,
  },
})

export default i18n
